import { Col, Row } from 'reactstrap';
import React, { useCallback } from 'react';
import SearchInput from 'components/SearchInput';
import { useApiGet } from 'hooks/useApi';
import Pagination from 'models/Pagination';
import PaginationNav from 'components/Pagination';
import { Link, useNavigate } from 'react-router-dom';
import Icon from 'components/Icon';
import Table from 'components/Table';
import { Column } from 'components/Table/_presenters/props/tableComponentProps';
import AdminUser from 'models/AdminUser';

const AdminUsersListPage = () => {
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = React.useState({
    pageSize: 10,
    page: 1,
    search: ''
  });
  const { data: UsersPage, isLoading } = useApiGet<Pagination<AdminUser>>(
    '/admin/auth/users',
    {
      params: filteredData
    }
  );

  const handleSearch = useCallback(
    (search: string) => {
      setFilteredData({ ...filteredData, search });
    },
    [filteredData]
  );

  const handleClearFilter = useCallback(() => {
    setFilteredData({ pageSize: 10, page: 1, search: '' });
  }, []);

  const handlePageChange = useCallback(
    (page: number) => {
      setFilteredData({ ...filteredData, page });
    },
    [filteredData]
  );

  const goToEdit = useCallback(
    (user: AdminUser) => {
      navigate(`/admin/auth/users/${user.id}`);
    },
    [navigate]
  );

  const columns: Column<AdminUser>[] = [
    {
      accessor: 'firstName',
      label: 'Nome',
      render: (name) => <span className="fw-medium">{String(name)}</span>
    },
    {
      accessor: 'email',
      label: 'E-mail',
      render: (email) => <span>{String(email)}</span>
    },
    {
      accessor: 'actions',
      label: 'Ações',
      render: () => <Icon icon="eye" className="text-primary" />
    }
  ];

  return (
    <div className="padding-page">
      <Row className="d-flex flex-column flex-md-row">
        <Col className="col-12 col-md">
          <div>
            <p className="text-gray-600">Administração</p>
            <h4 className="fw-bold">Usuários Admin</h4>
            <span className="small-typography text-gray-600">
              Gerencie os usuários administradores da plataforma.
            </span>
          </div>
        </Col>
        <Col className="col-12 col-md align-text mt-3 mt-md-0">
          <Link
            to="/admin/auth/users/create"
            className="btn btn-primary text-white button-register"
          >
            Cadastrar
          </Link>
        </Col>
      </Row>
      <Row className="d-flex align-items-center mt-2 flex-column flex-md-row">
        <Col className="col-12 col-md">
          <SearchInput
            onClearFilter={handleClearFilter}
            onSearchTextChange={handleSearch}
            placeholder="Buscar usuário"
          />
        </Col>
      </Row>
      <Table
        data={UsersPage?.items || []}
        columns={columns}
        isLoading={isLoading}
        onRowClick={goToEdit}
      />
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row mt-3">
        {UsersPage && (
          <PaginationNav
            onChange={handlePageChange}
            totalPages={UsersPage.totalPages}
            currentPage={UsersPage.page}
          />
        )}
      </div>
    </div>
  );
};

export default AdminUsersListPage;
